import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const billingHooks = {
  useGetBillingPortalUrl: () =>
    trpc.billing.getBillingPortalUrl.useMutation({
      onSuccess: (data) => {
        window.location.href = data.url
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Laskutusportaalin avaaminen epäonnistui',
          color: 'red',
        })
      },
    }),

  useCreateCheckoutSession: () =>
    trpc.billing.createCheckoutSession.useMutation({
      onSuccess: (data) => {
        if (data.url) {
          window.location.href = data.url
        }
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Maksusession luominen epäonnistui',
          color: 'red',
        })
      },
    }),

  useAcceptOfferCheckout: () =>
    trpc.billing.acceptOfferCheckout.useMutation({
      onSuccess: (data) => {
        if (data.url) {
          window.location.href = data.url
        }
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Tarjouksen hyväksyminen epäonnistui',
          color: 'red',
        })
      },
    }),
}
